import React, { Component } from 'react';
import { Card, Dimmer } from "tabler-react";
import { Radar } from 'react-chartjs-2'

class GraficaEntregas extends Component {
  constructor(props){
    super(props);
    this.state = ({
      data: [],
      maxAlumnos: 0,
      graficaData: {},
      isLoading: true
    });
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.data !== this.props.data) {
      this.setState({data: this.props.data});
      this.setGraphData(); 
    }
  }

  componentDidMount = async () => {
  }

  setGraphData () {
    let countAlumnos = 0;
    for (let index in this.props.data.alumnos) {
      if (this.props.data.alumnos[index].cursoNombre === this.props.curso.cursosNombres && this.props.data.alumnos[index].cursoId === this.props.curso.cursosId) {
        countAlumnos++;
      }
    }
    let dataForGraph = [];
    for (const property in this.props.data.dataColumnas[0]) {
      if (Number.isInteger(this.props.data.dataColumnas[0][property])) {
        dataForGraph.push(`${this.props.data.dataColumnas[0][property]}`);
      }
    }
    let labelsForGraph = [];
    for (let index in this.props.data.actividades.assigns) {
      labelsForGraph.push([this.props.data.actividades.assigns[index].name.substring(0,27),[this.props.data.actividades.assigns[index].name.substring(28,70)]]);
    }

    this.setState({
      isLoading: false,
      maxAlumnos: countAlumnos,
      graficaData: {
      labels: labelsForGraph,
      datasets: [
        {
          label: 'Entregas',
          data: dataForGraph,
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1,
        },
      ],
    }});

  }

  render() {
    return(
      <>
      <Dimmer loader active={this.state.isLoading}>
        <Radar
          data={this.state.graficaData}
          width={500}
          height={500}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            scale: {
              r: {
                suggestedMax: this.state.maxAlumnos,
                suggestedMin: 0
              },
              ticks: { 
                beginAtZero: true,
                precision: 0
              },
            },
          }}
        />
      </Dimmer>
      </>
    );
  }
}
export default GraficaEntregas;